<script setup lang="ts">
import { NutritionalValues } from '@/types/api/api-v3/product'

type Props = {
  nutritionalValue: NutritionalValues
}

const props = defineProps<Props>()

const isTooltipShow = ref(false)
</script>

<template>
  <div class="product__tooltip">
    <div
      class="product__tooltip-trigger"
      @mouseover="isTooltipShow = !isTooltipShow"
      @mouseout="isTooltipShow = !isTooltipShow"
    >
      <div>КБЖУ</div>
    </div>
    <div
      v-if="isTooltipShow"
      class="product__tooltip-content product__calories"
    >
      <h4 class="product__calories-headline">Пищевая ценность на 100 г</h4>
      <table class="product__calories-table">
        <tbody>
          <tr>
            <td>{{ props.nutritionalValue.protein }}</td>
            <td>{{ props.nutritionalValue.fat }}</td>
            <td>{{ props.nutritionalValue.carbohydrate }}</td>
            <td>{{ props.nutritionalValue.calorific }}</td>
          </tr>
          <tr>
            <th>белки</th>
            <th>жиры</th>
            <th>углеводы</th>
            <th>Ккал</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product__tooltip {
  position: relative;

  &-trigger {
    padding: 3px 5px;
    font-size: 9px;
    font-weight: 800;
    color: var(--ui-unactive-gray);
    text-transform: uppercase;
    cursor: pointer;
    background-color: var(--ui-grey);
    border-radius: 6px;

    &:hover {
      color: var(--ui-text-primary);
      background-color: $carousel-dot-background;
    }
  }

  &-content {
    position: absolute;
    bottom: 120%;
    left: -130%;
    z-index: 9;
    padding: 22px 15px;
    background-color: #000;
    border-radius: 20px;
  }

  .product__calories {
    &-headline {
      margin-bottom: 5px;
      font-size: 12px;
      font-weight: 800;
      color: var(--ui-white);
      text-align: center;
    }

    &-table {
      font-size: 12px;
      color: var(--ui-white);
      border-spacing: 10px 0;

      tr {
        td {
          height: max-content;
          font-size: 12px;
          font-weight: 800;
        }

        th {
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
